export default {"src":"/_next/static/media/Download.860b34b2.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};